import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NG_ENTITY_SERVICE_CONFIG } from '@datorama/akita-ng-entity-service';
import { AkitaNgRouterStoreModule } from '@datorama/akita-ng-router-store';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { QuillModule } from 'ngx-quill';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { registerLocaleData } from '@angular/common';
import { ProjectModule } from './project/project.module';
import vi from '@angular/common/locales/vi';
registerLocaleData(vi);
/** config ng-zorro-antd i18n **/
import { NZ_I18N, vi_VN } from 'ng-zorro-antd/i18n';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { NZ_CONFIG } from 'ng-zorro-antd/core/config';
export function HttpLoaderFactory(http: HttpClient){
  return new TranslateHttpLoader(http);
}
const ngZorroConfig = {
  notification: {
    nzMaxStack: 100,
  },
};
@NgModule({
  declarations: [AppComponent,],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    ProjectModule,
    NzSpinModule,
    // EditorModule,
    NzIconModule.forRoot([]),
    // environment.production ? [] : AkitaNgDevtools,
    AkitaNgRouterStoreModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    QuillModule.forRoot()
  ],
  providers: [
    {
      provide: NG_ENTITY_SERVICE_CONFIG,
      useValue: { baseUrl: 'https://jsonplaceholder.typicode.com' }
    },
    {
      provide: NZ_I18N, useValue: vi_VN
    },
    { 
      provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true 
    },
    { 
      provide: NZ_CONFIG, useValue: ngZorroConfig 
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
